import { createSelector } from 'reselect';

const selectOnboardingModalDomain = state => state?.onboardingModal;

export const makeSelectOnboardingModals = createSelector(
  selectOnboardingModalDomain,
  substate => substate?.onboardingModals,
);

export const makeSelectOnboardingModalsLoading = createSelector(
  selectOnboardingModalDomain,
  substate => substate?.onboardingModalsLoading ?? false,
);
